import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.compact.css";
import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Form,
  Navbar,
  Button,
  Overlay,
  Popover,
  Card,
  Figure,

} from "react-bootstrap";

import { logoutACTION } from "../../redux-store/actions/authActions";
import SidebarMenus from "./SidebarMenus";
import { useAuth } from "../../hooks/useAuth";
import HeaderSubMenus from "./HeaderSubMenus";
import HeaderSubMenusChilds from "./HeaderSubMenusChilds";
import { menuList } from "../../helper/constants/menus";
import config from 'devextreme/core/config';
import { licenseKey } from '../../devextreme-license.ts';
import { allowViewMenu } from "../../helper/functions/general-func.js";
import { MenuRoutes } from "../../helper/constants/general-const.js";
config({ licenseKey });
const Layout = () => {

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { logout, user } = useAuth();
  const location = useLocation();
  const isMobile = window.outerWidth < 1024;
  const displayName = user?.firstName;
  // hide/show sidebar
  const [displaySidebar, SetSidebar] = useState(isMobile ? "" : "sidebar-visible");
  // toggle user settings dropdown
  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState({});
  const [selectedChildMenuData, setSelectedChildMenuData] = useState({});

  const ref = useRef(null);

  const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`);
    displaySideBarByScreen();
  }
  useEffect(() => {
    window.addEventListener("resize", documentHeight);
    documentHeight();

  }, [])

  setTimeout(() => {
    const activeMenu = document.querySelector(".sidebar-item-active");
    const activeChildMenu = document.querySelector(".headersubmenuactive.active")
    const activeChildSubMenu = document.querySelector(".headerSubMenusChild.active");

    if (activeChildSubMenu) {
      document.title = activeChildSubMenu.innerText;
    }
    else if (activeChildMenu) {
      document.title = activeChildMenu.innerText;
    }
    else if (activeMenu) {
      document.title = activeMenu.innerText;
    }
  }, 0.1);

  useEffect(() => {
    if (isMobile) {
      SetSidebar("");
    }
  }, [location]);

  useEffect(() => {

    const locationPathInfo = location.pathname.split("/");
    let parentMenuId = null;
    let childMenuId = null;
    let childSubMenuId = null;
    let childSubChildId = null;
    let ActiveMenuId = null;
    if (locationPathInfo.length) {
      parentMenuId = locationPathInfo[1].toLowerCase();
    }
    if (locationPathInfo.length > 2) {
      childMenuId = locationPathInfo[2].toLowerCase();
    }
    if (locationPathInfo.length > 3) {
      childSubMenuId = locationPathInfo[3].toLowerCase();
    }
    if (locationPathInfo.length > 4) {
      childSubChildId = locationPathInfo[4].toLowerCase();
    }
    const findMenu = (menuId, menus) => menus.find(menu => menu.MenuId.toLowerCase() === menuId);
    const parentMenu = findMenu(childMenuId, menuList);
    const childMenu = parentMenu?.SubMenu ? findMenu(childSubMenuId, parentMenu.SubMenu) : null;
    setSelectedMenu(parentMenu);
    setSelectedChildMenuData(childMenu);

    ActiveMenuId = childSubChildId ? childSubChildId : childSubMenuId ? childSubMenuId : childMenuId ? childMenuId : parentMenuId ? parentMenuId : null;

    handleNavigation(ActiveMenuId);

    displaySideBarByScreen();

  }, [location?.pathname]);

  const displaySideBarByScreen = function(){
   
      const locationPathInfo = location.pathname.split("/");
      if(locationPathInfo && locationPathInfo.length && ["orders","products"].indexOf(locationPathInfo[locationPathInfo.length-1].toLowerCase())!="-1"){
        if(window.outerWidth <= 1499){
          SetSidebar("");
        }
        else{
            SetSidebar("sidebar-visible");
        }
     
      }
     

  
  }


  const handleNavigation = (activeMenu) => {

    if (activeMenu) {
      if (!allowViewMenu(activeMenu)) {
        navigate("/accessdenied")
      }
    }
    else {
      const firstViewablePage = user.permissions.find(permission => permission.isView);

      if (firstViewablePage) {
        const routeKey = Object.keys(MenuRoutes).find(key => MenuRoutes[key] === firstViewablePage.pageName);

        if (routeKey) {
          navigate(`/admin/${routeKey}`);

        } else {
          console.log('No matching route found for page:', firstViewablePage.pageName);
        }
      } else {
        console.log('No pages available with view permission.');
      }
    }

  };


  const LogoutUser = () => {
    dispatch(logoutACTION())
      .then((d) => {
        logout();
        navigate('/login');
      })
      .catch(() => {

      });

  }
  const handleClick = (event) => {
    setShow(!show);
    setTarget(event.target);
  };

  function ManageSidebar() {
    SetSidebar(displaySidebar === "" ? "sidebar-visible" : "");
  }

  return (
    <div id="layout-wraper" className={`app-main ${displaySidebar}`} >
      <SidebarMenus displaySidebar={displaySidebar} />
      <div className="min-vh-100 main-content p-0">
        <Navbar className="main-header">
          <i className="fa-solid fa-bars ms-2 me-4 sidebar-ctrl-i" onClick={() => ManageSidebar()}></i>
          <Form className="d-flex w-100 justify-content-end align-items-center">
            <div className="pe-3 position-relative" ref={ref}>
              <i className="fa-solid fa-circle-user header-links header-icon" onClick={handleClick}></i>
              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                onHide={() => setShow(!show)}
                rootClose={true}
              >
                <Popover id="popover-contained">
                  <Popover.Body>
                    <Card className="text-center">

                      <Card.Body>
                        <Card.Title>
                          <Figure>

                            <Figure.Caption className="text-uppercase">
                              {displayName.charAt(0)}
                            </Figure.Caption>
                          </Figure>
                        </Card.Title>
                        <Card.Text className="mb-0 text-capitalize">
                          {displayName}
                        </Card.Text>


                      </Card.Body>
                      <Card.Footer className="text-muted bg-transparent"><Button variant="primary" onClick={() => LogoutUser()} className="btn-sm w-100">Sign Out</Button></Card.Footer>
                    </Card>

                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Form>
        </Navbar>

        {selectedMenu && selectedMenu.SubMenu ?
          <HeaderSubMenus scrlmenu={selectedMenu.MenuId} childmenus={selectedMenu} />
          : <></>
        }
        {selectedChildMenuData && selectedChildMenuData.SubMenu ?
          <HeaderSubMenusChilds scrlmenu={selectedChildMenuData.MenuId} childmenus={selectedChildMenuData} />
          : <></>
        }
        <div className="clearfix"></div>

        <Container fluid >
          <Outlet />
        </Container>
      </div>
    </div>
  )
}

export default Layout;